<select-many-search-api
    [fetchData]="fetchData"
    [fetchSelected]="fetchSelected"
    (selectChange)="emitEvent($event)"
    (selectChangeComplete)="emitEventComplete($event)"
    (selectOrderChange)="emitOrderChange($event)"
    (itemsAdded)="emitItemsAdded($event)"
    (itemsRemoved)="emitItemsRemoved($event)"
    (accountsChange)="filterByAccount($event)"
    [allowAccountSelection]="allowAccountSelection"
    [allowedAccountIds]="allowedAccountIds"
    (closeWithoutChange)="closeWithoutChange.emit()"
    [apiModel]="api_model"
    [openOnInit]="openOnInit"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [disable_items]="disable_items"
    [required]="required"
    [stringFunction]="stringFunction"
    [removeItemDisabled]="removeItemDisabled"
    [compareFunctionName]="compareFunctionName"
    [value]="value"
    [classes]="classes"
    [label]="label"
    [userSorted]="userSorted"
    style="min-width:inherit;max-width:inherit;">
</select-many-search-api>
